import { format, formatDistanceToNow, parseISO, isValid } from 'date-fns';

function parseDate(date: string | Date | null | undefined): Date | null {
  if (!date) return null;
  const d = typeof date === 'string' ? parseISO(date) : date;
  return isValid(d) ? d : null;
}

export function formatDate(date: string | Date | null | undefined): string {
  const d = parseDate(date);
  if (!d) return 'N/A';
  return format(d, 'MMM d, yyyy');
}

export function formatDateTime(date: string | Date | null | undefined): string {
  const d = parseDate(date);
  if (!d) return 'N/A';
  return format(d, 'MMM d, yyyy h:mm a');
}

export function formatRelativeTime(date: string | Date | null | undefined): string {
  const d = parseDate(date);
  if (!d) return 'N/A';
  return formatDistanceToNow(d, { addSuffix: true });
}

export function formatNumber(num: number): string {
  return new Intl.NumberFormat().format(num);
}

export function formatCredits(credits: number): string {
  return credits.toLocaleString();
}

export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
}

export function truncate(str: string, length: number): string {
  if (str.length <= length) return str;
  return str.slice(0, length) + '...';
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_-]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
